import type { ReportPdfRequest, ReportPdfResponse } from '@src/models/interfaces/reportPdf.interface';
import { ReportPdfRepository } from '@src/repositories/ReportPdfRepository';

const repository = new ReportPdfRepository();

export const ReportPdfService = {
  generate: (request: ReportPdfRequest): Promise<ReportPdfResponse> => repository.generate(request),
};
